// extracted by mini-css-extract-plugin
module.exports = {"dates":"DateRange_dates__OI0TW","MuiDateRangeCalendar-root":"DateRange_MuiDateRangeCalendar-root__LndJS"};